import { api } from '../lib/api';

export interface PurchaseOrderListItem {
  id: number;
  poNumber: string;
  supplierId: number | null;
  supplierName: string | null;
  status: string;
  orderDate: string;
  expectedDeliveryDate: string | null;
  notes: string | null;
  totalQty: string | number;
  receivedQty: string | number;
  rowCount: number;
}

export interface PurchaseOrderRow {
  id?: number;
  productId: number;
  description: string | null;
  qty: number;
  receivedQty?: number;
  uomItemId: number | null;
  unitPriceExVat?: number | null;
  vatRateItemId?: number | null;
  rowTotalExVat?: number | null;
  siteId?: number | null;
  waterPercent?: number | null;
  nectarItemId?: number | null;
  notes?: string | null;
  productSku?: string | null;
  productName?: string | null;
  productKind?: string | null;
  categoryLabel?: string | null;
  nectarLabel?: string | null;
  uomLabel?: string | null;
  siteName?: string | null;
  containerId?: number | null;
  containerCode?: string | null;
}

export interface PurchaseOrderDetail {
  id: number;
  poNumber: string;
  supplierId: number | null;
  supplierName: string | null;
  status: string;
  orderDate: string;
  expectedDeliveryDate: string | null;
  supplierSnapshotJson: Record<string, unknown> | null;
  notes: string | null;
  rows: PurchaseOrderRow[];
}

export interface PurchaseOrdersMeta {
  suppliers: Array<{ id: number; name: string }>;
  products: Array<{
    id: number;
    sku: string | null;
    name: string;
    kind: string | null;
    defaultUomItemId: number | null;
    categoryItemId: number | null;
    categoryLabel: string | null;
  }>;
  uoms: Array<{ id: number; label: string }>;
  sites: Array<{ id: number; name: string }>;
  nectars: Array<{ id: number; label: string }>;
  statuses: string[];
}

export interface PurchaseOrderFormData {
  poNumber: string;
  supplierId: number | null;
  status: string;
  orderDate: string;
  expectedDeliveryDate?: string | null;
  notes?: string;
  rows: Array<{
    productId: number;
    description?: string | null;
    qty: number;
    uomItemId?: number | null;
    siteId?: number | null;
    waterPercent?: number | null;
    nectarItemId?: number | null;
    notes?: string | null;
  }>;
}

export const purchaseOrdersApi = {
  list: () => api.get<{ purchaseOrders: PurchaseOrderListItem[] }>('/purchase-orders'),
  meta: () => api.get<PurchaseOrdersMeta>('/purchase-orders/meta'),
  get: (id: number) => api.get<PurchaseOrderDetail>(`/purchase-orders/${id}`),
  create: (data: PurchaseOrderFormData) => api.post<{ id: number; poNumber: string }>('/purchase-orders', data),
  update: (id: number, data: PurchaseOrderFormData) => api.patch<{ ok: boolean }>(`/purchase-orders/${id}`, data),
};
